import React from "react";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { Field, FormSection } from "redux-form";
import { Col } from "react-bootstrap";
import {
  DESCRIPTION,
  PART,
  PART_DESCRIPTION,
  PART_NUMBER
} from "MODULES/parts/constants";
import {
  CurrencyField,
  FormInput,
  Select,
  TextArea
} from "MODULES/shared/components/Forms";
import { properCase } from "LIB/formatters/text";
import { COST, NOTES, QUANTITY } from "APP_ROOT/constants";
import {
  CONDITION,
  TAG_DATE,
  TAGGED_BY,
  TRACED_TO
} from "MODULES/inventories/constants";
import { toOptions } from "LIB/forms";
import { CONDITION_TYPES } from "MODULES/inventories/components/Detail/Dummies/constants";
import { AWAITING_REPLY } from "MODULES/RepairQuotes/constants";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";
import { NO_QUOTE } from "MODULES/IncomingQuotes/constants";
import { QUOTE_TYPE } from "MODULES/OutgoingQuotes/constants";
import MonthYearField from "../../shared/components/Forms/MonthYearField";
import Check from "../../shared/components/Forms/Check";
import CheckGroup from "../../shared/components/Forms/Check/CheckGroup";

function Row({ fields, incomingQuote, getFieldValue, setFieldValue }) {
  const quoteType = item => getFieldValue(`${item}.quote_type`);
  const disabled = item =>
    quoteType(item) !== AWAITING_REPLY || incomingQuote.customer_submitted_at;

  return fields.map((item, idx) => (
    <FormSection name={item}>
      {idx !== 0 ? <hr /> : <div style={{ marginTop: 10 }} />}
      <FormRow>
        <FormSection name={PART}>
          <Col md={3}>
            <Field
              name={PART_NUMBER}
              component={FormInput}
              label={properCase(PART_NUMBER)}
              disabled
              required
            />
          </Col>
          <Col md={3}>
            <Field
              name={DESCRIPTION}
              component={FormInput}
              label={properCase(PART_DESCRIPTION)}
              disabled
              required
            />
          </Col>
        </FormSection>
        <Col md={3}>
          <Field
            name={QUANTITY}
            component={FormInput}
            label="Qty"
            required={quoteType(item) !== NO_QUOTE}
            disabled={disabled(item)}
          />
        </Col>
        <Col md={3}>
          <Field
            disabled={disabled(item)}
            name={CONDITION}
            component={Select}
            options={toOptions(CONDITION_TYPES)}
            label={properCase(CONDITION)}
            required={quoteType(item) !== NO_QUOTE}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col md={3}>
          <CurrencyField name={COST} label="Price" disabled={disabled(item)} />
        </Col>
        <Col md={3}>
          <Field
            disabled={disabled(item)}
            name={TAGGED_BY}
            component={FormInput}
            label={properCase(TAGGED_BY)}
          />
        </Col>
        <Col md={3}>
          <MonthYearField
            disabled={disabled(item)}
            name={TAG_DATE}
            component={FormInput}
            label={properCase(TAG_DATE)}
          />
        </Col>
        <Col md={3}>
          <Field
            disabled={disabled(item)}
            name={TRACED_TO}
            component={FormInput}
            label={properCase(TRACED_TO)}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col md={4}>
          <CheckGroup title="No Quote">
            <Check
              onChange={() => {
                const val =
                  quoteType(item) === NO_QUOTE ? AWAITING_REPLY : NO_QUOTE;
                setFieldValue([item, QUOTE_TYPE].join("."))(val);
                if (val === NO_QUOTE) {
                  [
                    COST,
                    TAGGED_BY,
                    TAG_DATE,
                    TRACED_TO,
                    QUANTITY,
                    CONDITION
                  ].forEach(f => setFieldValue([item, f].join("."))(null));
                }
              }}
              input={{
                name: `${item}.no_quote`,
                value: quoteType(item) === NO_QUOTE,
                onChange: () => {}
              }}
              label="No Quote"
              disabled={
                ![NO_QUOTE, AWAITING_REPLY].includes(quoteType(item)) ||
                incomingQuote.customer_submitted_at
              }
            />
          </CheckGroup>
        </Col>
      </FormRow>
      <FormRow>
        <Col md={12}>
          <Field
            name={NOTES}
            component={TextArea}
            label="Note"
            rows={5}
            disabled={disabled(item)}
          />
        </Col>
      </FormRow>
    </FormSection>
  ));
}

export default withFieldAccessors(Row);



// WEBPACK FOOTER //
// ./app/modules/Customers/IncomingQuote/Row.jsx